export const OWNER_COMMITMENT_OPERATIONAL_STATE = Object.freeze({
  READY: "ready",
  IN_PROGRESS: "in_progress",
  WAITING: "waiting",
  BLOCKED: "blocked",
});

export const OWNER_COMMITMENT_OPERATIONAL_OPTIONS = Object.freeze([
  { value: OWNER_COMMITMENT_OPERATIONAL_STATE.READY, label: "Lista para hacer", shortLabel: "Lista", executable: true },
  { value: OWNER_COMMITMENT_OPERATIONAL_STATE.IN_PROGRESS, label: "En curso", shortLabel: "En curso", executable: true },
  { value: OWNER_COMMITMENT_OPERATIONAL_STATE.WAITING, label: "Esperando algo / a alguien", shortLabel: "Esperando", executable: false },
  { value: OWNER_COMMITMENT_OPERATIONAL_STATE.BLOCKED, label: "Bloqueada por una traba", shortLabel: "Bloqueada", executable: false },
]);

const KNOWN = new Set(OWNER_COMMITMENT_OPERATIONAL_OPTIONS.map((option) => option.value));

export function commitmentOperationalState(commitment) {
  if (String(commitment?.status || "open") !== "open") return null;
  const explicit = String(commitment?.work?.state || "");
  if (KNOWN.has(explicit)) return explicit;
  if (commitment?.projectRole === "blocker") return OWNER_COMMITMENT_OPERATIONAL_STATE.BLOCKED;
  return OWNER_COMMITMENT_OPERATIONAL_STATE.READY;
}

export function isCommitmentExecutable(commitment) {
  const state = commitmentOperationalState(commitment);
  return state === OWNER_COMMITMENT_OPERATIONAL_STATE.READY || state === OWNER_COMMITMENT_OPERATIONAL_STATE.IN_PROGRESS;
}

export function isCommitmentNonExecutable(commitment) {
  const state = commitmentOperationalState(commitment);
  return state === OWNER_COMMITMENT_OPERATIONAL_STATE.WAITING || state === OWNER_COMMITMENT_OPERATIONAL_STATE.BLOCKED;
}

export function commitmentOperationalMeta(commitment) {
  const state = commitmentOperationalState(commitment);
  return OWNER_COMMITMENT_OPERATIONAL_OPTIONS.find((option) => option.value === state) || null;
}

export function commitmentOperationalDetail(commitment) {
  const state = commitmentOperationalState(commitment);
  if (state === OWNER_COMMITMENT_OPERATIONAL_STATE.WAITING) return String(commitment?.work?.waitingFor || "").trim();
  if (state === OWNER_COMMITMENT_OPERATIONAL_STATE.BLOCKED) return String(commitment?.work?.blockedBy || "").trim();
  return "";
}

export function dateTimeInputValue(value) {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  const pad = (number) => String(number).padStart(2, "0");
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

export function commitmentWorkFormValue(commitment) {
  const state = commitmentOperationalState(commitment) || OWNER_COMMITMENT_OPERATIONAL_STATE.READY;
  return {
    state,
    waitingFor: state === OWNER_COMMITMENT_OPERATIONAL_STATE.WAITING ? String(commitment?.work?.waitingFor || "") : "",
    blockedBy: state === OWNER_COMMITMENT_OPERATIONAL_STATE.BLOCKED ? String(commitment?.work?.blockedBy || "") : "",
    reviewAt: [OWNER_COMMITMENT_OPERATIONAL_STATE.WAITING, OWNER_COMMITMENT_OPERATIONAL_STATE.BLOCKED].includes(state)
      ? dateTimeInputValue(commitment?.work?.reviewAt)
      : "",
  };
}

export function commitmentWorkPayload(work = {}) {
  const state = KNOWN.has(String(work.state || "")) ? String(work.state) : OWNER_COMMITMENT_OPERATIONAL_STATE.READY;
  return {
    state,
    waitingFor: state === OWNER_COMMITMENT_OPERATIONAL_STATE.WAITING ? String(work.waitingFor || "").trim() : "",
    blockedBy: state === OWNER_COMMITMENT_OPERATIONAL_STATE.BLOCKED ? String(work.blockedBy || "").trim() : "",
    reviewAt: [OWNER_COMMITMENT_OPERATIONAL_STATE.WAITING, OWNER_COMMITMENT_OPERATIONAL_STATE.BLOCKED].includes(state)
      ? (work.reviewAt || null)
      : null,
  };
}
